// ************** start Size-Chart-block ************** //
document.addEventListener("DOMContentLoaded", function() {
  const btns = document.querySelectorAll(".size-chart-btn");
  btns.forEach(btn => {
    btn.addEventListener("click", function() {
      const modal = this.closest(".size-chart-block").nextElementSibling;
      if(modal) modal.style.display = "flex";
    });
  });
  const closes = document.querySelectorAll(".close-size");
  closes.forEach(span => {
    span.addEventListener("click", function() {
      this.parentElement.parentElement.style.display = "none";
    });
  });
  window.addEventListener("click", function(event) {
    const modals = document.querySelectorAll(".size-chart-modal");
    modals.forEach(modal => {
      if(event.target === modal) modal.style.display = "none";
    });
  });
});
// ************** end Size-Chart-block ************** //